"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHackerUITheme = exports.HACKER_ORANGE_COLOR = exports.HACKER_PINK_COLOR = exports.HACKER_RED_COLOR = exports.HACKER_GREEN_COLOR = void 0;
const react_1 = require("@chakra-ui/react");
const config = {
    initialColorMode: 'dark',
    useSystemColorMode: false,
};
exports.HACKER_GREEN_COLOR = '#16E951';
exports.HACKER_RED_COLOR = '#F81236';
exports.HACKER_PINK_COLOR = '#FF009C';
exports.HACKER_ORANGE_COLOR = '#F89C12';
const styles = {
    global: {
        body: {
            bg: '#000000',
            color: exports.HACKER_GREEN_COLOR,
            fontFamily: 'Roboto Mono',
        },
    },
};
const themeExtension = {
    config,
    fonts: {
        heading: 'Roboto Mono',
        body: 'Roboto Mono',
        pixel: 'Pixelar Regular W01 Regular',
    },
    colors: {
        hackerGreen: exports.HACKER_GREEN_COLOR,
        hackerRed: exports.HACKER_RED_COLOR,
        hackerPink: exports.HACKER_PINK_COLOR,
        hackerOrange: exports.HACKER_ORANGE_COLOR,
    },
    styles,
};
exports.defaultHackerUITheme = (0, react_1.extendTheme)(themeExtension);
//# sourceMappingURL=theme.js.map